import { appLinks } from "../config/appLinks";
import { useTranslation } from "../i18n/LocaleContext";

// O glifo "↗" não é decorativo: a validação da loja exige sinalizar que o link leva o
// usuário para fora do Teams. aria-hidden porque o texto do link já descreve o destino.
export function ExternalLink({
  href,
  label,
  className = "app-footer-link",
}: {
  href: string;
  label: string;
  className?: string;
}) {
  return (
    <a className={className} href={href} target="_blank" rel="noreferrer">
      {label}
      <span className="app-footer-external" aria-hidden="true">
        ↗
      </span>
    </a>
  );
}

// Caminho adiante padrão das telas de erro e de bloqueio. A validação da loja exige que a
// informação de contato seja um hyperlink, não texto puro.
export default function SupportLink({ className }: { className?: string }) {
  const { t } = useTranslation();
  return <ExternalLink href={appLinks.support} label={t("app.support.cta")} className={className} />;
}
